import { render, staticRenderFns } from "./UploadFormComponent.vue?vue&type=template&id=69683432"
import script from "./UploadFormComponent.vue?vue&type=script&lang=js"
export * from "./UploadFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports